import PixelMap from "../PixelMap";

export default function pixelMap() {
	return PixelMap();
}
